var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invoice-list"},[_c('CommonList',{ref:"commonList",attrs:{"bottomBtnText":"分享","showTop":false,"cellOperabled":false,"showBottom":true},on:{"onSubmit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }